<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/dictation/index')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش دیکته</v-card-title>
      <v-card-text v-if="!loading">
        <v-row>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="dictation.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="dictation.label" label="لیبل"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select label="دسته بندی" :items="categories" item-text="label" item-value="id"
                      color="black" v-model="dictation.category_id">
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-select label="وضعیت نمایش"
                      :items="[{text:'قابل مشاهده',value:1},{text:'غیر قابل مشاهده',value:0}]"
                      color="black" v-model="dictation.visibility">
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-text-field type="number" color="black" v-model="dictation.order" label="اولویت"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field type="number" color="black" v-model="dictation.percent_per_wrong"
                          label="تعداد دفعات مجاز"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field type="number" color="black" v-model="dictation.tries"
                          label="از ۱۰۰ کم می شود به ازای هر غلط"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select label="نوع"
                      :items="[{value:'button',text:'انتخاب پاسخ با دکمه ها'},{value:'keyboard',text:'نوشتن پاسخ با کیبورد'}]"
                      item-text="text" item-value="value"
                      color="black" v-model="dictation.type">
            </v-select>
          </v-col>
          <v-col cols="4">
            <v-text-field label="کاور"
                          @click="coverDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="dictation.cover_file"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field label="فایل صوتی"
                          @click="fileDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="dictation.file"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn color="primary" @click="addDictationCount()">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
            تعداد دیکته : {{ dictationCount }}
            <v-btn color="warning" @click="reduceDictationCount()">
              <v-icon>
                mdi-minus
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-textarea color="black" v-model="dictation.description" label="توضیحات دیکته"></v-textarea>
          </v-col>

          <v-col cols="6">
            <v-textarea color="black" v-model="dictation.comment" label="دست نوشته دیکته"
                        hint="این نوشته سمت کاربر نمایش داده نمی شود و فقط برای یادداشت شما می باشد که در جستجو از آن استفاده کنید."></v-textarea>
          </v-col>


          <v-col cols="12">
            <v-divider style="background-color: red!important;"></v-divider>
          </v-col>


          <v-col cols="6" v-for="count in dictationCount" :key="count+'dictation-child'">
            <v-row>
              <v-col cols="12">
                <v-text-field label="فایل صوتی"
                              @click="openChildFileDialog(count-1)" prepend-icon="mdi-plus"
                              color="black"
                              v-model="dictation.children[count-1].file"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete multiple :items="alphabets" item-value="id" item-text="label" color="black"
                                v-model="dictation.children[count-1].options" label="گزینه های دیکته"
                                hint=" گزینه های قابل انتخاب کاربر است که باید از بین آن ها به صورت صحبح انتخاب کند."></v-autocomplete>
              </v-col>

              <v-col cols="12">
                پاسخ دیکته :
                <br>
                <v-btn text @click="addAnswers(count-1)">
                  <v-icon color="primary">mdi-plus</v-icon>
                </v-btn>
                <v-btn text @click="reduceAnswers(count-1)">
                  <v-icon color="error">mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" v-for="(answer , index) in dictation.children[count-1].answers"
                     :key="index + 'answer'+count">
                <v-autocomplete :items="alphabets" item-text="label" item-value="id" label="الفبا را انتخاب کنید"
                                v-model="answer.alphabet_id"></v-autocomplete>
                <v-text-field type="number" v-model="answer.order" label="اولویت"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="coverDialog" max-width="50vw">
      <drag-and-drop module="alphabet" ref="image-uploader" @closeUploadFileDialog="coverDialog = false"
                     @changeFile="dictation.cover = $event"></drag-and-drop>
    </v-dialog>
    <v-dialog v-model="fileDialog" max-width="50vw">
      <drag-and-drop module="dictation-audio" ref="image-uploader" @closeUploadFileDialog="fileDialog = false"
                     @changeFile="dictation.file = $event"></drag-and-drop>
    </v-dialog>
    <v-dialog v-model="childFileDialog" max-width="50vw">
      <drag-and-drop module="dictation-child-audio" ref="image-uploader"
                     @closeUploadFileDialog="childFileDialog = false"
                     @changeFile="dictation.children[currentChildIndex].file = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
  name: "DictationEdit",
  components: {DragAndDrop},
  data() {
    return {
      loading: true,
      categories: [],
      alphabets: [],
      coverDialog: null,
      fileDialog: null,
      childFileDialog: null,
      dictationCount: 1,
      currentChildIndex: 0,
      dictation: {
        title: null,
        label: null,
        category_id: null,
        description: null,
        order: null,
        cover_file: null,
        file: null,
        comment: null,
        type: null,
        visibility: null,
        percent_per_wrong: null,
        tries: null,
        children: [
          {
            file: null,
            options: null,
            answers: [
              {
                alphabet_id: null,
                order: null
              }
            ],
          }
        ],
      },
    }
  },
  mounted() {
    this.getCategories()
    this.getAlphabets()
    this.getDictation()
  },
  methods: {
    openChildFileDialog(currentChildIndex) {
      this.currentChildIndex = currentChildIndex
      this.childFileDialog = true
    },
    addDictationCount() {
      this.dictation.children.push({
        file: null,
        options: null,
        answers: [
          {
            alphabet_id: null,
            order: null
          }
        ],
      })
      this.dictationCount++
    },
    reduceDictationCount() {
      if (this.dictationCount > 1) {
        this.dictation.children.pop()
        this.dictationCount--
      }
    },
    addAnswers(index) {
      let answer = {
        alphabet_id: null,
        order: null
      }
      this.dictation.children[index].answers.push(answer)
    }
    ,
    reduceAnswers(index) {
      if (this.dictation.children[index].answers.length > 1) {
        this.dictation.children[index].answers.pop();
      }
    },
    getAlphabets() {
      window.axios.get('course/dictation/alphabet/index?per_page=1000').then((res) => {
        this.alphabets = res.data.data.data
      })
    },
    getCategories() {
      window.axios.get('category/index?per_page=1000&type=item_file').then((res) => {
        this.categories = res.data.data.data
      })
    },
    getDictation() {
      window.axios.get('course/dictation/get/' + this.$route.params.id).then((res) => {
        console.log(res.data.data)
        this.dictation = {
          title: res.data.data.title,
          label: res.data.data.label,
          category_id: res.data.data.category_id,
          description: res.data.data.description,
          order: res.data.data.order,
          cover_file: res.data.data.cover_file,
          file: res.data.data.file,
          comment: res.data.data.comment,
          type: res.data.data.type,
          visibility: res.data.data.visibility,
          percent_per_wrong: res.data.data.percent_per_wrong,
          tries: res.data.data.tries,
          children: [
            {
              file: null,
              options: null,
              answers: [
                {
                  alphabet_id: null,
                  order: null
                }
              ],
            }
          ],
        }
        res.data.data.children.forEach((child) => {
          let options = child.options.split(',').map(Number);
          let answers = child.correct_answer.split(',').map((id, index) => {
            return {
              alphabet_id: Number(id),
              order: index + 1
            };
          });
          this.dictation.children.push({
            file: child.file,
            options: options,
            answers: answers,
          })
          this.dictationCount++
        })
        this.dictationCount--
        this.dictation.children.splice(0, 1);
        this.loading = false
      })
    },
    update() {
      window.axios.post('course/dictation/update/' + this.$route.params.id, this.dictation).then(() => {
        this.openSnackbar("دیکته مورد نظر با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
  }
}
</script>

<style scoped>

</style>